import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import InputField from '../../../../components/InputFields/InputField';
import { EventDeviationDto } from '../../../../interfaces/IEvent';

interface DeviationDialogProps {
    open: boolean;
    onClose: () => void;
    deviation?: EventDeviationDto;
    updateDeviation: (deviation: EventDeviationDto) => void;
}

export default function DeviationDialog({open, onClose, deviation, updateDeviation}: DeviationDialogProps) {
    
    const handleClose = () => {
        updateDeviation(deviation ?? {text: '', isDeviation: false});
        onClose();
    };
    
    const handleUpdate = () => {
        updateDeviation({
            text: deviation?.text ?? '',
            isDeviation: true
        });
        onClose();
    };
    
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>Finnes det avvik?</DialogTitle>
            <DialogContent>
                <InputField
                    name='deviation'
                    placeholder='Skriv inn avvik her (ikke påkrevd)'
                    value={deviation?.text}
                    onChange={(e) => updateDeviation({
                        text: e.target.value,
                        isDeviation: false
                    })}
                    multiline
                    rows={12}
                />
            </DialogContent>
            <DialogActions>
                <Button 
                    variant='contained'
                    onClick={handleClose}
                    color="warning"
                >
                    Nei
                </Button>
                <Button
                    variant='contained' 
                    onClick={handleUpdate} 
                    color="primary"
                >
                    Ja
                </Button>
            </DialogActions>
        </Dialog>
    );
    }